/*
 * Copyright (c) 2021 LucidResolutions LLC. All rights reserved.
 */

import {generateUUID} from "../lib/uuid";
const pathRegex = /[/]+/g

export class ExternalApiBase {
    baseUrl;
    pathPrefix;
    worker;
    pendingRequests = {};
    defaultContentType;
    allAsJson = true;

    constructor(baseUrl = '') {
        this.baseUrl =  baseUrl || '';
        this.worker = new Worker("/workers/requests.js")
        this.worker.onmessage = ($event)=>{
            let data = $event.data
            let requestID = data?.requestID
            if(!requestID){return}

            let resolveReject = this.pendingRequests[requestID]
            if(!resolveReject){return;}
            delete this.pendingRequests[requestID]
            let [resolve, reject] = resolveReject
            if(data.success){
                resolve(data.response)
            } else {
                reject(data.response)
            }
        }
    }

    contentType(type){
        this.defaultContentType = type;
        return this
    }

    useAllAsJson(b){
        this.allAsJson = b
        return this
    }


    usePathPrefix(prefix){
        this.pathPrefix = prefix;
        if(this.pathPrefix){
            let prefix = `/${this.pathPrefix}`
            this.baseUrl = `${this.baseUrl}${prefix.replace(pathRegex, '/')}`
        }

        return this
    }

    async path(path) {
        if(path){
            path = `/${path}`
        } else {
            path = ''
        }

        let url = `${this.baseUrl}${path.replace(pathRegex, '/')}`

        return url
    }

    async rawRequest(type, path, config = {}){
        let evID = `external.api.${generateUUID()}`
        let isJson = this.allAsJson

        if(!config.headers || !config.headers['Content-Type']) {
            config.headers = {
                ...(config.headers || {}),
               // 'Content-Type': 'application/json'
            }
        }
        if(!config.mode){
            config.mode = 'cors'
            //config.headers[]
        }

        let promise = new Promise((resolve, reject)=>{
            this.pendingRequests[evID] = [resolve, reject]
        })

        this.worker.postMessage({
            fn: 'fetch',
            isJson: isJson,
            requestID: evID,
            url: path,
            args: {
                ...config,
                referrer: 'about:client',
                referrerPolicy: 'no-referrer'
            }
        })

        return promise
    }

    async delete(path, config = {}) {
        return await this.rawRequest('DELETE', await this.path(path), {
            ...config
        })
    }

    async get(path, config = {}) {
        return await this.rawRequest('GET', await this.path(path), {
            ...config,
        })
    }

    async post(path, data, config = {}) {
        return await this.rawRequest('POST', await this.path(path), {
            body: data,
            ...config
        })
    }

    async patch(path, data, config = {}) {
        return await this.rawRequest('PATCH', await this.path(path), {
            body: data,
            ...config
        })
    }

    async put(path, data, config = {}) {
        return await this.rawRequest('PUT', await this.path(path), {
            body: data,
            ...config
        })
    }
}
